import React, { memo, useEffect, useRef, useState } from "react";
import { ImageComp } from "../../components/Image/Image";
import { Animated, Pressable, Text, View } from "react-native";
import { getCleanUrl } from "../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import { useCssStyle } from "../../customHook/getCssStyle";
import { setRedirectToTabId } from "../../Redux/Reducers/appConfigReducer";
import { myStayTab } from "../../config/Constant";
import { useIsFocused } from "@react-navigation/native";

const TabBar = memo(({ state, navigation, handleFooterNavClick }) => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const isFocused = useIsFocused();

    const { isLoggedIn, redirectToTabId } = useSelector(state => state.appConfigSlice)
    const { isBookingFound } = useSelector(state => state.checkInSlice.bookingStatus);

    const { currentLayout } = useSelector(state => state.deviceConfigSlice,);
    const tabDetails = currentLayout?.tabDetails || [];

    const [tabBarWidth, setTabBarWidth] = useState(0);
    const tabWidth = tabBarWidth / state.routes.length;

    const translateX = useRef(new Animated.Value(0)).current;



    const getDefaultFooter = () => {
        let requiredTabIndex = 0;

        if (tabDetails?.length > 0) {
            if (redirectToTabId) {
                // Find the tab with the uniqueKey that matches initialTabId
                const requiredTabItem = tabDetails.findIndex(tabItem =>
                    redirectToTabId.includes(tabItem.uniqueKey.replace(/ /g, '').toLowerCase())
                );
                if (requiredTabItem >= 0) {
                    requiredTabIndex = requiredTabItem;
                }
            } else if (isLoggedIn || isBookingFound) {
                // Find the "my stay" tab
                const myStayTabItem = tabDetails.findIndex(tabItem =>
                    myStayTab.includes(tabItem.uniqueKey.replace(/ /g, '').toLowerCase())
                );

                if (myStayTabItem >= 0) {
                    requiredTabIndex = myStayTabItem;
                }
            }
            
            
            if(state.index != requiredTabIndex){
                setTimeout(() => {
                    handleFooterNavClick(tabDetails[requiredTabIndex], navigation)
                }, 0);
            }

        }
    };

    useEffect(() => {

        if (redirectToTabId) {
            getDefaultFooter();
            dispatch(setRedirectToTabId(null));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [redirectToTabId])

    useEffect(() => {
        // select required footer tab
        if (isLoggedIn || (isBookingFound && isFocused)) {
            getDefaultFooter();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, isBookingFound]);

    useEffect(() => {
        if (tabBarWidth > 0) {
            // Accomodate for tab bar padding as we do absolute positioning.
            const { paddingLeft } = getStyles(["tabBarStyle"]);
            Animated.spring(translateX, {
                toValue: state.index * tabWidth + paddingLeft,
                useNativeDriver: false,
            }).start();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.index, tabWidth]);

    return (
        <View style={getStyles(["tabBarStyle"])}
            onLayout={(event) => {
                const { width } = event.nativeEvent.layout;
                // Accomodate for a tab bar narrower than the screen as we do absolute positioning.
                const { paddingLeft, paddingRight } = getStyles(["tabBarStyle"]);
                setTabBarWidth(width - paddingLeft - paddingRight);
            }}
            id="tabBarStyle"
        >
            {/* Sliding Indicator */}
            <Animated.View
                style={[
                    getStyles(["tabContainerTopBorder_container"]),
                    {
                        width: tabWidth,
                        transform: [{ translateX: translateX }],
                    },
                ]}
                id={"tabContainerTopBorder_container"}
            >
                <View style={getStyles(["tabContainerTopBorder"])} />
            </Animated.View>

            <View style={[getStyles(["tabParentContainer"]), { flex: 1, flexDirection: "row" }]} id="tabParentContainer">
                {state.routes.map((route, index) => {
                    const tab = tabDetails.find((tab) => tab.uniqueKey === route.name);
                    const isFocused = state.index === index;

                    return (
                        <Pressable
                            key={route.key}
                            onPress={() => handleFooterNavClick(tab, navigation)}
                            style={({ pressed }) =>
                                getStyles([
                                    "tabContainer",
                                    isFocused && "tabFocusedContainer",
                                    {
                                        opacity: pressed ? 0.7 : 1,
                                        transform: [{ scale: pressed ? 0.95 : 1 }],
                                    },
                                ])
                            }
                            id={`tabContainer tabContainer_${route.name}`}
                        >
                            <ImageComp
                                source={isFocused && tab.tabFocusedIconUrl ? getCleanUrl(tab.tabFocusedIconUrl) : getCleanUrl(tab?.tabIconUrl)}
                                style={getStyles(["tabIcon", isFocused && "tabIconFocused"])}
                                id={`tabIcon tabIcon_${route.name}`}
                            />
                            <Text style={getStyles(["tabLabel", isFocused && "tabLabelFocused"])} id="tabLabel">
                                {tab?.tabName}
                            </Text>
                        </Pressable>
                    );
                })}
            </View>
        </View>
    );
});


export default TabBar;